import type { OutputRenderContext } from '../../tool-config-types';
import { getPortalToolDisplayConfig } from './portal-tool-display-config';

export function renderPortalToolResult({
  content,
  toolName,
}: OutputRenderContext & { toolName: string }): string | undefined {
  const displayConfig = getPortalToolDisplayConfig(toolName);
  if (!displayConfig) {
    return typeof content === 'string' ? content : undefined;
  }

  return displayConfig.formatResultSummary(content) ?? undefined;
}

export function createPortalToolResultRenderer(toolName: string) {
  return (ctx: OutputRenderContext) =>
    renderPortalToolResult({ ...ctx, toolName });
}
